import { render, staticRenderFns } from "./Salutation.vue?vue&type=template&id=eaf6ca3a&scoped=true"
import script from "./Salutation.vue?vue&type=script&lang=js"
export * from "./Salutation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf6ca3a",
  null
  
)

export default component.exports